// @flow
import PageList from 'components/page/PageList';
import { connect } from 'react-redux';
import { fetchPageList } from 'actions/pageActions';

import type { DispatchProps } from 'components/page/PageList';
import type { DispatchType, StateType } from 'types/Actions';
import type {StateProps} from 'components/page/PageList';
import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      title: state.pageListState.title,
      description: state.pageListState.description,
      label: state.pageListState.label,
      featured_media: state.pageListState.featured_media,
      liste_cards: state.cardState.liste_cards,
      articles: state.newsletterCategoryState.articles,
      status: state.pageListState.status,
      template: state.pageListState.template,
      liste_enfants: state.pageListState.liste_enfants,
      news: state.pageListState.news,
      meta_title: state.pageListState.meta_title,
      meta_description: state.pageListState.meta_description,
      redirection: state.pageListState.redirection,
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchPageList: (slug: string) => dispatch(fetchPageList(slug))
    })
  )(PageList)
);
